import { render } from "./FooterCncd.vue?vue&type=template&id=388f1460&scoped=true"
import script from "./FooterCncd.vue?vue&type=script&lang=js"
export * from "./FooterCncd.vue?vue&type=script&lang=js"

import "./FooterCncd.vue?vue&type=style&index=0&id=388f1460&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388f1460"]])

export default __exports__